import {Component, Input} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-valid-input',
    templateUrl: './valid-input.component.html',
    styleUrls: ['./valid-input.component.scss'],
    standalone: false
})
export class ValidInputComponent {

  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() controlText: Observable<string>;
  @Input() errors: any;
  @Input() showValid = true;

  private focused: boolean;

  public getTooltip() {
    let txt;
    this.controlText.subscribe(text => txt = this.isRequired() ? text + '': text);
    return txt;
  }

  getValidationErrorCodes(): string {
    return this.errors.map(error => Object.keys(error)[0]);
  }

  isRequired(): boolean {
    return this.getValidationErrorCodes().includes('required');
  }

  errorDetected(errorIndex: number): boolean {
    const control = this.formGroup.get(this.controlName);
    return control.invalid  && control.errors && control.errors[this.getValidationErrorCodes()[errorIndex]];
  }

  errorMessage(errorIndex: number): any {
    const error = this.errors[errorIndex];
    return  Object.values(error)[0];
  }

  onFocus() {
    this.focused = true;
  }

  onBlur() {
    this.focused = false;
  }

  isFocused(): boolean {
    return this.focused;
  }


}
